import { Button } from "@material-ui/core"
import { getClientsData } from "clients/services/reducers"
import SelectField from "common/components/SelectField"
import { getTasksData } from "common/store/reducers/tasks"
import SearchField from "invoices/components/SearchField"
import React from "react"

export const referenceField = (props, onOpenDetail, fieldName = "numInvoice") => {
    return (
        <Button variant="outlined"
            style={{ width: '100%', color: 'black', fontWeight: 'bold', border: '2px solid black' }}
            onClick={() => onOpenDetail(props)}>
            {props ? props[fieldName] : ""}
        </Button>
    )
}

export const searchClientsField = (rowData, props, onFilterItems) => {
    const clientsToSearch = getClientsData(props.clientsMap).sort((c1, c2) => c2.lastUpdated - c1.lastUpdated)

    return (
        <SearchField
            textInitial={rowData.nameClient}
            onTextRender={item => item.name}
            items={clientsToSearch}
            onFilterItems={(itemList, textFilter) =>
                onFilterItems({
                    itemList,
                    textFilter,
                    fieldsFilter: ["name", "id"]
                })
            }
            onSelectItem={item => {
                rowData.nameClient = item.name
                rowData.dniClient = item.id
            }}
            onRenderItem={(item) => item.id + " " + item.name}
        />
    )
}

export const selectPaymentModeField = ({ rowData, mapPaymentMode, value }, onChangePaymentMode) => {
    return (
        <SelectField
            mapData={mapPaymentMode} 
            value={value} 
            handleChangeValue={value => onChangePaymentMode(rowData, value)}
        />
    )
}

export const searchTasksField = (rowData, props, onFilterItems) => {
    const tasksToSearch = getTasksData(props.tasksMap).sort(((t1, t2) => t2.dateEntry - t1.dateEntry))

    return (
        <SearchField
            textInitial={rowData.taskReference}
            onTextRender={item => item.reference}
            items={tasksToSearch}
            onFilterItems={(itemList, textFilter) =>
                onFilterItems({
                    itemList,
                    textFilter,
                    fieldsFilter: ["reference", "description"]
                })
            }
            onSelectItem={item => {
                rowData.taskReference = item.reference
                rowData.newTask = true
            }}
            onRenderItem={item => item.reference + " " + item.description}
        />
    )
}